import styled from 'styled-components';
import {
  robotoRegular,
  scarpaGray900,
  scarpaGray600,
  scarpaGray500,
  scarpaGray50,
  white,
  tomatoCoral50,
  tomatoCoral600,
  electricPurple600,
  monserratSemiBold
} from '@habitech/shared';

export const Wrapper = styled.div`
  min-height: 100vh;
  background: ${scarpaGray50};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  font-family: ${robotoRegular};
`;

export const Card = styled.div`
  background: ${white};
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 40px;
  width: 100%;
  max-width: 520px;
`;

export const Header = styled.div`
  margin-bottom: 32px;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-weight: 400;
  color: ${scarpaGray900};
  margin: 0 0 8px;
  font-family: ${monserratSemiBold};
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${scarpaGray600};
  margin: 0;
  line-height: 1.6;
  font-family: ${robotoRegular};
`;

export const Section = styled.div`
  margin-bottom: 24px;
`;

export const SectionLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: ${scarpaGray500};
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-family: ${robotoRegular};
`;

export const ErrorText = styled.p`
  font-size: 13px;
  color: ${tomatoCoral600};
  background: ${tomatoCoral50};
  border-radius: 6px;
  padding: 8px 12px;
  margin: 8px 0 0;
  font-family: ${robotoRegular};
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  color: ${electricPurple600};
  font-family: ${robotoRegular};
  font-weight: 600;
  margin-bottom: 20px;

  &:hover {
    opacity: 0.75;
  }
`;

export const InputGroup = styled.div`
  .form-control {
    font-size: 14px;

    &::placeholder {
      font-size: 14px;
    }
  }
`;
